import React, { Component } from 'react';
import connect from 'react-redux/es/connect/connect';
import { createSelector } from 'reselect';
import LaddaButton, {EXPAND_RIGHT} from 'react-ladda';
import SimpleReactValidator from 'simple-react-validator';
import { history } from '../../../helpers';
import { itemService, globalService as gs } from '../../../common/services';
import { alertSelectors } from '../../../common/redux/selectors';

class UpdatePassword extends Component {
    constructor(props) {
        super(props);
        this.state = {
            formField: {
                oldPassword: '',
                newPassword: '',
                confirmNewPassword: '',
            },
            loading: false
        };
        this.validator = new SimpleReactValidator({
            autoForceUpdate: this,
            className: 'valid-feedback d-block text-danger',
        });
    }

    handleChange = (e) => {
        let formField = {...this.state.formField};
        formField[e.target.name] = e.target.value;
        this.setState({formField});
    }

    handleSubmit = (e) => {
        e.preventDefault();

        if( this.validator.allValid() ){
            const { dispatch } = this.props;
            this.setState({loading: true});
            itemService.changePassword("POST", this.state.formField )
            .then(response => {
                dispatch(alertSelectors.success(response.message));
                this.setState({loading: false});
                history.goBack();
            })
            .catch(exception => {
                gs.showErrors(dispatch, exception, alertSelectors);
                this.setState({loading: false});
            });
        } else {
            this.validator.showMessages();
            this.forceUpdate();
        }
    };
    
    render() {
        this.validator.purgeFields();
        const { formField, loading } = this.state;
        const { oldPassword, newPassword, confirmNewPassword } = formField;
        return (
            <form name="change_password" onSubmit={this.handleSubmit} encType="multipart/form-data" noValidate>
                <div className="form-group">
                    <label>Current Password <span className="text-danger">*</span></label>
                    <input type="password" className="form-control" placeholder="Old password" name="oldPassword" value={oldPassword} onChange={this.handleChange} />
                    {this.validator.message('oldPassword', oldPassword, 'required')}
                </div>
                <div className="form-group">
                    <label>New Password<span className="text-danger">*</span></label>
                    <input type="password" className="form-control" placeholder="New password" name="newPassword" value={newPassword} onChange={this.handleChange} />
                    {this.validator.message('newPassword', newPassword, 'required|min:6')}
                </div>
                <div className="form-group">
                    <label>Confirm New Password <span className="text-danger">*</span></label> 
                    <input type="password" className="form-control" placeholder="Confirm Password" name="confirmNewPassword" value={confirmNewPassword} onChange={this.handleChange} />
                    {this.validator.message('confirmNewPassword', confirmNewPassword, `required|in:${newPassword}`)}
                </div>
                <div className="form-group">
                    <LaddaButton className="btn btn-primary px-5" loading={loading} data-style={EXPAND_RIGHT}>Submit </LaddaButton>
                </div>
            </form>
        );
    }
}

const processSelector = createSelector(
    state => state.process,
    process => process
);

const mapStateToProps = createSelector(
    processSelector,
    (process) => ({
        process
    })
);

export default connect(mapStateToProps)(UpdatePassword);